module.exports = __webpack_public_path__ + "img/rbcn_pro_show_5_h.acb988f7.jpg";